import React from 'react';
import './loader.css';

function Loader() {
  return (
    <div className='loader'>
        Avishekh
    </div>
  )
}

export default Loader